"use client";

import Link from "next/link";
import Checkbox from "./Checkbox";
import { useState } from "react";
import { useStaticStore } from "app/hooks";
import { STORE_KEYS } from "app/constants";
import Image from "next/image";
import { ClosePopupIcon } from "./Icons";
import Cookies from "js-cookie";

export function PopupContentCampaign({
  imageId,
  imageUrl,
  linkUrl,
  imageWidth,
  imageHeight,
  sessionStatus,
}: {
  imageId: number | undefined;
  imageUrl: string;
  linkUrl: string;
  imageWidth: number;
  imageHeight: number;
  sessionStatus: "authenticated" | "loading" | "unauthenticated";
}) {
  const [checked, setChecked] = useState(false);
  const { mutate: setIsOpen } = useStaticStore(STORE_KEYS.popup);
  const handleSubmit = () => {
    if (checked && sessionStatus === "unauthenticated" && imageId) {
      //「表示しない」にチェック入れて閉じた場合はcookieに保存
      Cookies.set("no_show_next" + imageId, String(imageId), { expires: 7 });
    }
    setIsOpen(false);
  };
  return (
    <div>
      <Link
        className="dialog-campaign-link"
        href={linkUrl}
        onClick={() => {
          setIsOpen(false);
        }}
      >
        <figure className="dialog-campaign-fig">
          <Image
            className="dialog-campaign-img"
            width={imageWidth}
            height={imageHeight}
            src={imageUrl}
            alt=""
          />
        </figure>
      </Link>

      <div className="dialog-chk-wrap mode-campaign">
        <Checkbox
          className="dialog-chk mode-campaign"
          label={<span className="auth-legal-label">次回から表示しない</span>}
          checked={checked}
          onChange={() => setChecked((prev) => !prev)}
          useIcon={true}
        />
      </div>
      <div className="dialog-btns">
        <button
          type="submit"
          className="dialog-btn mode-campaign"
          onClick={() => {
            handleSubmit();
          }}
        >
          <ClosePopupIcon
            className="dialog-popup-close"
            size={40}
            aria-label="ポップアップを閉じる"
          />
        </button>
      </div>
    </div>
  );
}
